import React from 'react';
import { getDic } from '../../assets/i18n/dictionary';
import {
  FormRow,
  FormColumn,
  InputField,
  Button,
  TextSmall,
} from '../../components';
import fileUtils from '../../utils/fileUtils';
import * as Icons from '@mui/icons-material';
import imageCompression from 'browser-image-compression';

const Step2SendImageForm = (props) => {
  const {
    dimensions,
    configOptions,
    tryCaptureFace,
  } = props;

  const width = dimensions.width < 640 ? dimensions.width - 40 : 600;
  const [file, setFile] = React.useState('');

  const getBase64FromImage = React.useCallback(async () => {
    if (!file) {
      return;
    }
    const _compressedFile = await imageCompression(file.files[0], {
      maxSizeMB: 2,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    });
    let _base64 = await fileUtils.convertFileToBase64(_compressedFile);
    tryCaptureFace(_base64);
  }, [file]);

  return (
    <>
      <FormRow justifyContent='center' paddingTop={5}>
        <TextSmall align='center' color={configOptions.textColor}>
          {`- ${getDic("face-collector-step-2-a")}`}
        </TextSmall>
      </FormRow>
      <FormRow justifyContent='center' paddingTop={5}>
        <TextSmall align='center' color={configOptions.textColor}>
          {`- ${getDic("face-collector-step-2-b")}`}
        </TextSmall>
      </FormRow>
      <FormRow justifyContent='center' paddingTop={20}>
        <FormColumn width={width - 210} paddingRight={10}>
          <InputField
            title={`${getDic("selecionar")} ${getDic("arquivo")}`}
            onChange={v => setFile(v)}
            onPress={() => setFile('')}
            type='file'
            accept="image/png, image/jpeg"
            labelColor={configOptions.textColor}
          />
        </FormColumn>
        <FormColumn justifyContent='flex-end'>
          <FormRow paddingBottom={5}>
            <Button
              maxWidth={200}
              onPress={() => getBase64FromImage()}
              textColor={configOptions.buttonTextColor}
              background={configOptions.buttonBackgroundColor}
            >
              <FormRow justifyContent='center'>
                <FormColumn justifyContent='center' paddingRight={5}>
                  <TextSmall color={configOptions.buttonTextColor} fontWeight='bold'>{`${getDic("enviar")} ${getDic("imagem")}`}</TextSmall>
                </FormColumn>
                <Icons.CameraAlt style={{ color: configOptions.buttonTextColor, fontSize: 15 }} />
              </FormRow>
            </Button>
          </FormRow>
        </FormColumn>
      </FormRow>
    </>
  )
};

export default Step2SendImageForm;
